import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './EditScopeTabQuestionOptions.css'


const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const EditScopeTabQuestionOptions = (
    {
        errScopeOption,
        errScopeOptionClear,

        curScopeTabs,
        curScopeTab,
        curScopeQuestion,

        isOpen,

        scopeName,
        tabName,
        questionName,

        testData,
        testDetailData,

        saveOption,
        saveDetailOption,

        onDeleteOption,
        confirmDeleteOption,
        confirmDeleteOptionYes,
        confirmDeleteOptionNo,

        onStartOption,
        onStartDetailOption,

        onStopOption,
        onStopDetailOption,
 
        onRequestCancel
    }) => (
        <Modal isOpen={isOpen} style={styling}>
            <CommError error={errScopeOption.errorOption} onClose={errScopeOptionClear} />

            <ConfirmModal open={confirmDeleteOption} heading={"Delete Option"} msg={"Are you sure you want to delete this Option?"} onNo={confirmDeleteOptionNo} onYes={confirmDeleteOptionYes} />

            <div className="edit-scope-tab-question-options editpages productManagement">
                <div className="form-group">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-8 heading">
                                <h1>{scopeName} - {tabName} - {questionName} - Question Options</h1>
                                <span>Manage your data in the box provided below, click Add to create a new option</span><br />
                                <p onClick={onRequestCancel}><i className="fa fa-arrow-circle-left"></i>Questions</p>
                            </div>

                            <div className="col-md-4 button-options-container">
                                <button className="btn btn-primary pull-right" id="startoption" onClick={onStartOption}>+ Add Option</button>
                            </div>

                            <div className="row mainheader">
                                <div className="tableWrapper">
                                    {
                                        <div className="col-md-12 newoption">
                                            <p>Question Option:</p>
                                            <input className="newoption error" id="newquestionoption" onChange={testData} />

                                            <p>Option Help Text:</p>
                                            <input className="newoption" id="newquestionhelp" />

                                            <p>Option Order:</p>
                                            <input className="newoption error" id="newquestionorder" onChange={testData} />

                                            <div className="buttons">
                                                <a className="btn btn-default" onClick={onStopOption}>Cancel</a>
                                                <button className="btn btn-primary save newoption" onClick={saveOption}>Save</button>
                                            </div>
                                        </div>
                                    }

                                    <table className="lists table table-striped">
                                        <thead>
                                            <tr className="head">
                                                <th id="id">ID</th>
                                                <th>Option</th>
                                                <th>Order</th>
                                                <th>Active</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                curScopeTabs &&
                                                curScopeTabs[curScopeTab] &&
                                                curScopeTabs[curScopeTab].questions &&
                                                curScopeTabs[curScopeTab].questions[curScopeQuestion] &&
                                                curScopeTabs[curScopeTab].questions[curScopeQuestion].options ?
                                                    curScopeTabs[curScopeTab].questions[curScopeQuestion].options.map((option, index) => {
                                                        return ([<tr className="body option" optionindex={index} key={index}>
                                                            <td>{option.questionOptionID}</td>
                                                            <td option={option.questionOptionID} optionindex={index}>{option.optionName}</td>
                                                            <td>{option.optionOrder}</td>
                                                            <td>{option.isActive ? "Yes" : "No"}</td>
                                                            <td>
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>Edit Option</Tooltip>}>
                                                                    <i className="fa fa-edit" option={option.questionOptionID} optionindex={index} onClick={onStartDetailOption}></i>
                                                                </OverlayTrigger>
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>Delete Option</Tooltip>}>
                                                                    <i className="fa fa-remove" option={option.questionOptionID} onClick={onDeleteOption}></i>
                                                                </OverlayTrigger>
                                                            </td>
                                                        </tr>,
                                                        <tr className="detail" optionindex={index} key={index}>
                                                            <td>
                                                                <div className="detailcore">
                                                                    <p>Question Option:</p>
                                                                    <input className="detailoption option" onChange={testDetailData} optionindex={index} defval={option.optionName} defaultValue={option.optionName} />

                                                                    <p>Option Help Text:</p>
                                                                    <input className="detailoption help" optionindex={index} defval={option.helpText} defaultValue={option.helpText} />

                                                                    <p>Option Order:</p>
                                                                    <input className="detailoption order" onChange={testDetailData} optionindex={index} defval={option.optionOrder} defaultValue={option.optionOrder} />

                                                                    <div className="buttons">
                                                                        <a className="btn btn-default" cancel={index} onClick={onStopDetailOption}>Cancel</a>
                                                                        <button className="btn btn-primary save" option={option.questionOptionID} save={index} onClick={saveDetailOption}>Save</button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td className="last"></td>
                                                        </tr>,
                                                        <tr></tr>])
                                                    })
                                                : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );

// Modal.setAppElement('body');

export default EditScopeTabQuestionOptions